import { fetchBaseQuery, retry } from '@reduxjs/toolkit/dist/query';
import { generatePath } from 'react-router-dom';
import { APP_CONFIG } from '../../../config/appConfig';
import OAuthClient from '../../core/auth/AuthProvider/OAuthClient';

const baseQuery = fetchBaseQuery({
  baseUrl: APP_CONFIG.API_HOST,
  prepareHeaders: async (headers) => {
    headers.set('Authorization', `Bearer ${await OAuthClient.getAccessToken()}`);
    headers.set('Accept', 'application/json');
    return headers;
  },
});

export const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 });

export const generateEndpoint = generatePath;

export enum ENDPOINT_TAGS {
  AUTH = 'auth',
  CATEGORY = 'category',
  CATEGORY_WITH_ARTICLES = 'categoryWithArticles',
  CATEGORIES = 'categories',
  CATEGORIES_TREE = 'categoriesTree',
  ARTICLE = 'article',
  ARTICLES = 'articles',
  ARTICLES_SEARCH = 'articlesSearch',
  ARTICLES_MOST_SEARCHED = 'articlesMostSearch',
  ARTICLES_IN_CATEGORY = 'articlesInCategory',
}
